import * as React from 'react';
import { Input, InputProps } from './Input';
import { Icon } from '../icons/Icon';

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'rightContent'> {
  /** Show password by default */
  defaultShowPassword?: boolean;
  /** Aria label for show password button */
  ariaLabelShow?: string;
  /** Aria label for hide password button */
  ariaLabelHide?: string;
}

/**
 * Password input with show/hide toggle
 */
export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    {
      defaultShowPassword = false,
      ariaLabelShow = 'Show password',
      ariaLabelHide = 'Hide password',
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = React.useState(defaultShowPassword);

    const togglePasswordVisibility = () => {
      setShowPassword(prev => !prev);
    };

    return (
      <Input
        {...props}
        type={showPassword ? 'text' : 'password'}
        ref={ref}
        rightContent={
          <button
            type='button'
            onClick={togglePasswordVisibility}
            className='cursor-pointer hover:text-foreground-base transition-colors'
            aria-label={showPassword ? ariaLabelHide : ariaLabelShow}
            tabIndex={-1}
          >
            <Icon name={showPassword ? 'eye-slash' : 'eye'} className={'text-foreground-muted'} />
          </button>
        }
      />
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
